import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as NodeCSS from "./node.module.css";

export const AnalyticsBlock = memo(function AnalyticsBlock({
  sent,
  opened,
  clicks,
  revenue,
  skippedDueToUnsubscribe,
  skippedDueToSkipConditions,
}: {
  sent: number;
  opened: number;
  clicks: number;
  revenue: number;
  skippedDueToUnsubscribe: number;
  skippedDueToSkipConditions: number;
}) {
  const totalSkipped = skippedDueToUnsubscribe + skippedDueToSkipConditions;
  return (
    <Flex className={NodeCSS.analytics}>
      <Flex dir="column" w="full">
        <Flex justify="space-between">
          <Flex>
            <Text fontSize="xs">Sent</Text>
            <Text fontSize="xs" fontWeight="semibold">
              {typeof sent === "number" && sent !== 0
                ? sent.toLocaleString()
                : "-"}
            </Text>
          </Flex>
          <Flex>
            <Text fontSize="xs">Opened</Text>
            <Text fontSize="xs" fontWeight="semibold">
              {typeof opened === "number" && opened !== 0
                ? opened.toLocaleString()
                : "-"}
            </Text>
          </Flex>
        </Flex>
        <Flex justify="space-between">
          <Flex>
            <Text fontSize="xs">Clicks</Text>
            <Text fontSize="xs" fontWeight="semibold">
              {typeof clicks === "number" && clicks !== 0
                ? clicks.toLocaleString()
                : "-"}
            </Text>
          </Flex>
          <Flex>
            <Text fontSize="xs">Revenue</Text>
            <Text fontSize="xs" fontWeight="semibold">
              {typeof revenue === "number" && revenue !== 0
                ? `$${revenue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                : "-"}
            </Text>
          </Flex>
        </Flex>
        <Flex borderColor="primary" borderStyle="solid" borderTopWidth="1px" />
        <Flex justify="space-between">
          <Text fontSize="xs">Skipped</Text>
          <Text fontSize="xs" fontWeight="semibold">
            {typeof totalSkipped === "number" && totalSkipped !== 0
              ? totalSkipped.toLocaleString()
              : "-"}
          </Text>
        </Flex>
        <Flex justify="space-between" pl="lg">
          <Text className={NodeCSS.secondaryMetric} fontSize="xs">
            Not subscribed
          </Text>
          <Text fontSize="xs" fontWeight="semibold">
            {typeof skippedDueToUnsubscribe === "number" &&
            skippedDueToUnsubscribe !== 0
              ? skippedDueToUnsubscribe.toLocaleString()
              : "-"}
          </Text>
        </Flex>
        <Flex justify="space-between" pl="lg">
          <Text className={NodeCSS.secondaryMetric} fontSize="xs">
            Filtered
          </Text>
          <Text fontSize="xs" fontWeight="semibold">
            {typeof skippedDueToSkipConditions === "number" &&
            skippedDueToSkipConditions !== 0
              ? skippedDueToSkipConditions.toLocaleString()
              : "-"}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
});
